if (!customElements.get("timed-render")) {
  customElements.define(
    "timed-render",
    class TimedRender extends HTMLElement {
      #intervalId;
      #endTime;
      #disabledSelector;

      constructor() {
        super();
        // 初始化DOM元素引用
        this.daysElement = null;
        this.hoursElement = null;
        this.minutesElement = null;
        this.secondsElement = null;
        this.#disabledSelector = this.dataset.disabledSelector;
      }

      connectedCallback() {
        // 获取时间戳并验证
        const timestamp = new Date(this.dataset.time).getTime();
        if (isNaN(timestamp)) {
          console.error("Invalid data-time attribute");
          return;
        }

        // 初始化DOM引用
        this.daysElement = this.querySelector(".day");
        this.hoursElement = this.querySelector(".hour");
        this.minutesElement = this.querySelector(".minute");
        this.secondsElement = this.querySelector(".second");

        this.#endTime = timestamp; // 转换为毫秒
        this.#startCountdown();
      }

      disconnectedCallback() {
        this.#clearInterval();
      }

      #startCountdown() {
        this.#intervalId = setInterval(() => {
          const now = Date.now();
          const remaining = this.#endTime - now;

          if (remaining <= 0) {
            this.#updateDisplay(0, 0, 0, 0);
            this.#clearInterval();
            if (this.#disabledSelector) {
              document.querySelectorAll(this.#disabledSelector).forEach((element) => {
                element.setAttribute("disabled", "disabled");
              });
            }
            return;
          }

          const seconds = Math.floor(remaining / 1000);
          const days = Math.floor(seconds / 86400);
          const hours = Math.floor((seconds % 86400) / 3600);
          const minutes = Math.floor((seconds % 3600) / 60);
          const secs = seconds % 60;

          this.#updateDisplay(days, hours, minutes, secs);
        }, 1000);
      }

      #updateDisplay(d, h, m, s) {
        if (this.daysElement) this.daysElement.textContent = d.toString().padStart(2, "0");
        if (this.hoursElement) this.hoursElement.textContent = h.toString().padStart(2, "0");
        if (this.minutesElement) this.minutesElement.textContent = m.toString().padStart(2, "0");
        if (this.secondsElement) this.secondsElement.textContent = s.toString().padStart(2, "0");
      }

      #clearInterval() {
        if (this.#intervalId) {
          clearInterval(this.#intervalId);
          this.#intervalId = null;
        }
      }
    }
  );
}
